import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ru } from 'primelocale/ru.json';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = (!!environment.standName ? `(${environment.standName}) ` : '') + 'Интегратор';

  private primengConfig = inject(PrimeNGConfig);
  private titleService = inject(Title);

  constructor() {}

  ngOnInit() {
    this.primengConfig.setTranslation(ru);
    this.titleService.setTitle(this.title);
  }
}
